import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-superadmin-navbar',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule
  ],
  templateUrl: './superadmin-navbar.component.html',
  styleUrl: './superadmin-navbar.component.css'
})

export class SuperAdminNavbarComponent implements OnInit {
  isLoggedIn = false;
  mobileMenuOpen = false;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.checkUserSession();
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  async checkUserSession() {
    try {
      // Primero hacer una verificación local del token
      const hasToken = this.authService.hasValidToken();
      console.log('🔍 Token válido encontrado:', hasToken);
      this.isLoggedIn = hasToken;
      
      // Solo si hay token válido, intentar verificación completa
      if (hasToken) {
        try {
          const isAuthenticated = await this.authService.isAuthenticated();
          console.log('✅ Autenticación verificada:', isAuthenticated);
          this.isLoggedIn = isAuthenticated;
        } catch (authError) {
          console.warn('⚠️ Error en verificación de autenticación:', authError);
          // Mantener el estado basado en el token local
        }
      }
    } catch (error) {
      console.error('❌ Error checking user session:', error);
      this.isLoggedIn = false;
    }
  }

  async signOut() {
    try {
      console.log('🚪 Iniciando logout...');
      await this.authService.signOut();
      this.isLoggedIn = false;
      console.log('✅ Logout completado exitosamente');
      this.router.navigate(['/loggin']);
    } catch (error) {
      console.error('❌ Error durante logout:', error);
      // Incluso si hay error, limpiar el estado local
      this.isLoggedIn = false;
      this.router.navigate(['/loggin']);
    }
  }
}